import React from 'react'
import './DataPointIndicator.scss'

export type DataPointSet = {
  positions: number[]
  markerColors: string[]
}

export type DataPointIndicatorProps = {
  value: DataPointSet
}

function normalizePosition(position: number): number {
  // Map range [-100, 100] to [0, 100]
  return Math.round(((position + 100) / 2) * 1000) / 1000
}

function DataPointIndicator({ value }: Readonly<DataPointIndicatorProps>) {
  if (!value) return null

  const { positions, markerColors } = value
  const positionGroups = new Map<number, string[]>()

  positions.forEach((pos, index) => {
    // Validate range: only accept values between -100 and 100
    if (pos < -100 || pos > 100) {
      return
    }

    const normalizedPos = normalizePosition(pos)

    const existing = positionGroups.get(normalizedPos) ?? []
    existing.push(markerColors[index])
    positionGroups.set(normalizedPos, existing)
  })

  return (
    <div className="datapoint-container" role="presentation">
      <div className="datapoint-line" />
      {Array.from(positionGroups.entries()).map(([pos, groupMarkerColors]) => (
        <div key={pos} className="datapoint-group" style={{ left: `calc(${pos}% - 5px)` }}>
          {groupMarkerColors.map((color) => (
            <div key={color} className="datapoint-thumb" style={{ backgroundColor: color }} />
          ))}
        </div>
      ))}
    </div>
  )
}

export default DataPointIndicator
